import I18n from "../i18n/index.js.erb";

export default class FBLogin {
  constructor() {
    if (this.instance) {
      return this.instance;
    }
    this.instance = this;

    this.attach_logins();

    return this;
  }

  attach_logins() {
    $(document).on("turbolinks:load", () => {
      if ($("#pref_connect_fb")[0]) {
        this.attach_fb_login("pref_connect_fb");
      }
    });
  }

  fb_login(element, perms_string) {
    //element = $(element);
    console.log(element.className);
    let original_content = element.html();
    let button_id = element.parents("button")[0].id;

    if (
      (perms_string && perms_string.indexOf("public_profile") == -1) ||
      (navigator && navigator.vendor && navigator.vendor.indexOf("Apple") > -1)
    ) {
      //safari's popup blocker is stricker,quieter
      this.fb_login_ui(element, perms_string, original_content);
    } else {
      window.FB.getLoginStatus(function (response) {}, true); //REFRESH
      button_id.indexOf("connect") > -1
        ? element.html(I18n.t("client_global_copy.connecting"))
        : element.html(I18n.t("client_global_copy.logging"));

      if (window.FB.getAuthResponse()) {
        $.post(
          "/facebook/login",
          {
            original_content: original_content,
            button_id: button_id,
          },
          null,
          "script"
        );
      } else {
        this.fb_login_ui(element, perms_string, original_content);
      }
    }
  }

  fb_login_ui(element, perms_string, original_content) {
    perms_string =
      !perms_string || !perms_string.trim()
        ? "public_profile,user_birthday,user_link,email"
        : perms_string;
    var button_id = element.parents("button")[0].id;
    var phash = { scope: perms_string };
    if (perms_string.indexOf("public_profile") == -1) {
      //already got FB-enforced permission, now need email and maybe birthdate
      phash["auth_type"] = "rerequest";
    }
    FB.login(function (response) {
      if (response.authResponse) {
        FB.api("/me", function (response) {
          var params = {};
          if (typeof _jm != "undefined") {
            if (typeof _jm.nags == "number") {
              params.nags = _jm.nags;
            }
            if (typeof _jm.clicked == "number") {
              params.clicked = _jm.clicked;
            }
            if (typeof _jm.fb_button == "string") {
              params.fb_button = _jm.fb_button;
            }
          } else if (typeof window["fb_button_type"] == "string") {
            params.fb_button = window["fb_button_type"];
          }
          params.original_content = original_content;
          params.button_id = button_id;

          $.post("/facebook/login", params, null, "script");
          element.html(I18n.t("client_global_copy.welcome") + response.name);
        });
      } else {
        element.parents("button")[0].id.indexOf("connect") > -1
          ? element.html(I18n.t("into_block.connect") || "Connect")
          : element.html(I18n.t("client_global_copy.log_in"));
      }
    }, phash);
  }

  attach_fb_login(id, perms) {
    $(() => {
      $("#" + id).off("click");
      $("#" + id).on("click", (event) => {
        var button = event.currentTarget;
        var el = $(button).children(".fb_login_text");
        if (typeof _jm != "undefined") {
          _jm.fb_button = $(button).attr("rel");
        }
        this.fb_login(el, perms);
      });
    });
  }

  unattach_fb_login_and_attach_email_rerequest(id) {
    $(() => {
      $("#" + id).off("click");
      $("#" + id).on("click", (event) => {
        var button = event.currentTarget;
        var el = $(button).find(".fb_login_text");
        if (typeof _jm != "undefined") {
          _jm.fb_button = $(button).attr("rel");
        }
        this.fb_request_email(el);
      });
    });
  }

  fb_request_email(element) {
    this.fb_login(element, "email");
  }

  fb_login_status() {
    var r;
    window.FB.getLoginStatus(function (response) {
      // console.log(response);

      if (response.status === "connected") {
        // the user is logged in and has authenticated your
        // app, and response.authResponse supplies
        // the user's ID, a valid access token, a signed
        // request, and the time the access token
        // and signed request each expire

        // var uid = response.authResponse.userID;
        // var accessToken = response.authResponse.accessToken;
        r = true;
      } else if (response.status === "not_authorized") {
        // the user is logged in to Facebook,
        // but has not authenticated your app
        r = false;
      } else {
        // the user isn't logged in to Facebook.
        r = false;
      }
    });
    return r;
  }
}
